import Styles from '../../../styles/ShopData.module.css'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Divider from '@mui/material/Divider';
import { useState, useEffect } from 'react'
import { useOutletContext } from 'react-router-dom'
import { updateStore } from '../../../utils/database'
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { capitalizeText } from '../../../utils/strings';
import { FormControl, InputLabel } from "@mui/material"
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import OutlinedInput from '@mui/material/OutlinedInput';
import SaveBanner from '../../../components/SaveBanner';
import ListItemText from '@mui/material/ListItemText';
import Schedule from '../../../components/NewSchedule';
import { setIfValidPrice } from '../../../utils/strings';
import { storeIDIsAvailable } from '../../../utils/database';
import EasySnackBar from '../../../components/EasySnackBar';
import { updateMenuID } from '../../../utils/database';
import { PAYMENT_METHODS, DELIVERY_METHODS } from '../../../utils/structures';
import Helper from '../../../components/Helper';
import { useMediaQuery } from 'react-responsive';

export default function ShopData() {
    const [userAuth, userData, userMenu, updateUserData, updateUserMenu, setPreventNavigation] = useOutletContext()

    const [storeModified, setStoreModified] = useState(false)
    const [storeID, setStoreID] = useState('')
    const [storeIDAvailable, setStoreIDAvailable] = useState(null)
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [storePhone, setStorePhone] = useState('')

    const [facebook, setFacebook] = useState('')
    const [twitter, setTwitter] = useState('')
    const [instagram, setInstagram] = useState('')

    const [address, setAddress] = useState('')

    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')

    const [deliverySchedule, setDeliverySchedule] = useState(null)
    const [takeawaySchedule, setTakeawaySchedule] = useState(null)

    // from === to ? fixed cost
    // free === 0 ? free always
    // free > 0 ? free a partir de ese precio
    // free < 0 ? no envios gratis a ningun precio
    // from or to < 0 ? consultar
    const [deliveryCost, setDeliveryCost] = useState({ from: 0, to: 0, free: 0 })
    const [deliveryOptions, setDeliveryOptions] = useState([])
    const [paymentOptions, setPaymentOptions] = useState([])

    //{0}>Consultar //{1}>Precio fijo //{2}>Segun la distancia //{3}>Gratis
    const [prevDeliveryOption, setPrevDeliveryOption] = useState(0)
    const [deliveryOption, setDeliveryOption] = useState(0)
    const [offerFreeDelivery, setOfferFreeDelivery] = useState(false)

    const bigScreen = useMediaQuery({
        query: '(min-width: 600px)'
    })

    useEffect(() => {
        if (userMenu) {
            setStoreID(userData.menuid)
            setTitle(userMenu.title)
            setDescription(userMenu.description)
            setStorePhone(userMenu.phoneNumber)
            setFacebook(userMenu.socialMedia.fb)
            setTwitter(userMenu.socialMedia.tw)
            setInstagram(userMenu.socialMedia.ig)
            setAddress(userMenu.address)

            setDeliverySchedule(userMenu.schedule.delivery)
            setTakeawaySchedule(userMenu.schedule.takeaway)
            setDeliveryOptions(userMenu.deliveryOptions ? userMenu.deliveryOptions : [])
            setPaymentOptions(userMenu.paymentOptions ? userMenu.paymentOptions : [])

            setDeliveryCost(
                {
                    from: Math.max(userMenu.deliveryCost.from, 0),
                    to: Math.max(userMenu.deliveryCost.to, 0),
                    free: Math.max(userMenu.deliveryCost.free, 0)
                }
            )

            if (userMenu.deliveryCost.from < 0) {
                setDeliveryOption(0)
                setPrevDeliveryOption(0)

            } else if (userMenu.deliveryCost.free === 0) {
                setDeliveryOption(3)
                setPrevDeliveryOption(3)

            } else {
                if (userMenu.deliveryCost.from === userMenu.deliveryCost.to) {
                    setDeliveryOption(1)
                    setPrevDeliveryOption(1)
                } else {
                    setDeliveryOption(2)
                    setPrevDeliveryOption(2)
                }
            }
            setOfferFreeDelivery(userMenu.deliveryCost.free > 0)
        }
    }, [userMenu, userData])

    useEffect(() => {
        if (userData && userMenu) {

            if (storeID !== userData.menuid
                || title !== userMenu.title
                || description !== userMenu.description
                || storePhone !== userMenu.phoneNumber
                || facebook !== userMenu.socialMedia.fb
                || twitter !== userMenu.socialMedia.tw
                || instagram !== userMenu.socialMedia.ig
                || deliverySchedule !== userMenu.schedule.delivery
                || takeawaySchedule !== userMenu.schedule.takeaway
                || prevDeliveryOption !== deliveryOption
                || (prevDeliveryOption === 1 && deliveryCost.from !== userMenu.deliveryCost.from)
                || (prevDeliveryOption === 2 && (deliveryCost.from !== userMenu.deliveryCost.from || deliveryCost.to !== userMenu.deliveryCost.to))
                || (userMenu.deliveryCost.free >= 0 && deliveryCost.free !== userMenu.deliveryCost.free)
                || (userMenu.deliveryCost.free < 0 && offerFreeDelivery)
                || (paymentOptions !== userMenu.paymentOptions && userMenu.paymentOptions)
                || (paymentOptions.length >= 1 && !userMenu.paymentOptions)
                || (deliveryOptions !== userMenu.deliveryOptions && userMenu.deliveryOptions)
                || (deliveryOptions.length >= 1 && !userMenu.deliveryOptions)
                || address !== userMenu.address
            ) {
                setStoreModified(true)
                setPreventNavigation(true)
            } else {
                setStoreModified(false)
                setPreventNavigation(false)
            }
        }
    }, [storeID, title, description, storePhone, facebook, twitter, instagram, deliveryOptions,
        userMenu, deliverySchedule, takeawaySchedule, deliveryOption, deliveryCost, paymentOptions,
        address, offerFreeDelivery, prevDeliveryOption, setPreventNavigation, userData])

    const handleCheckToggle = (value, array, setFunction) => {

        //Si quieren setear esas opciones sin wpp tiro error
        if (setFunction === setDeliveryOptions && userMenu.phoneNumber === '') {
            if (value === DELIVERY_METHODS.delivery || value === DELIVERY_METHODS.takeaway) {
                setErrorMessage('Primero necesitas guardar un numero de Whatsapp para los pedidos')
                return
            }
        }

        const currentIndex = array.indexOf(value);
        const newChecked = [...array];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setFunction(newChecked)
    };

    const checkPhoneNumber = () => {
        const text = encodeURIComponent("Este deberia ser el numero de whatsapp de tu negocio donde recibirás los pedidos")

        // Create the WhatsApp link
        const link = `https://wa.me/${storePhone}?text=${text}`;

        // Open the WhatsApp app with the message ready to be sent
        window.open(link);
    }

    const onUpdate = async () => {
        let newValues = {}

        if (title !== userMenu.title) {
            newValues.title = capitalizeText(title)
        }
        if (description !== userMenu.description) {
            newValues.description = description.charAt(0).toUpperCase() + description.slice(1)
        }
        if (address !== userMenu.address) {
            newValues.address = capitalizeText(address)
        }
        if (storePhone !== userMenu.phoneNumber) {
            newValues.phoneNumber = storePhone
        }
        if (facebook !== userMenu.socialMedia.fb || twitter !== userMenu.socialMedia.tw || instagram !== userMenu.socialMedia.ig) {
            newValues.socialMedia = {}
            newValues.socialMedia.fb = facebook
            newValues.socialMedia.tw = twitter
            newValues.socialMedia.ig = instagram
        }
        if (deliverySchedule !== userMenu.schedule.delivery || takeawaySchedule !== userMenu.schedule.takeaway) {
            newValues.schedule = { delivery: deliverySchedule, takeaway: takeawaySchedule }
        }
        if (paymentOptions !== userMenu.paymentOptions) {
            newValues.paymentOptions = paymentOptions
        }
        if (deliveryOptions !== userMenu.deliveryOptions) {
            newValues.deliveryOptions = deliveryOptions
        }

        let from = 0, to = 0, free = 0
        switch (deliveryOption) {
            case 0:
                from = -1
                to = -1
                break
            case 1:
                from = parseFloat(deliveryCost.from)
                to = parseFloat(deliveryCost.to)
                break
            case 2:
                from = parseFloat(deliveryCost.from)
                to = parseFloat(deliveryCost.to)
                break
            case 3:
                from = 0
                to = 0
                free = 0
                break
            default:
                break
        }

        if (deliveryCost.free >= 0) {
            free = parseFloat(deliveryCost.free)
        } else {
            free = -1
        }

        newValues.deliveryCost = { from: from, to: to, free: free }

        // update new values in the DB
        updateStore(userAuth, userData.menuid, newValues)

        // get last values from DB
        updateUserMenu().then(async () => {
            if (storeID !== userData.menuid) {

                if (storeID.length === 0) {
                    setErrorMessage('El identificador debe tener al menos 1 caracter')

                } else {
                    const isAvailable = await storeIDIsAvailable(storeID)
                    setStoreIDAvailable(isAvailable)

                    if (isAvailable) {
                        updateMenuID(userAuth, userMenu, storeID, userData.menuid)
                            .then(updateUserMenu())
                    } else {
                        setErrorMessage('Para modificar el identificador primero debes comprobar su disponibilidad')
                    }
                }
            }
        }
        )

        setPreventNavigation(false)
        setStoreModified(false)
    }

    const checkIDAvailability = async () => {

        if (storeID.length === 0) {
            setErrorMessage('El identificador debe tener al menos 1 caracter')
            setStoreIDAvailable(false)

        } else {
            const isAvailable = await storeIDIsAvailable(storeID)
            if (isAvailable) {
                setSuccessMessage('El identificador se encuentra disponible, ya puedes guardar los cambios')
            } else {
                setErrorMessage('El identificador no se encuentra disponible')
            }

            setStoreIDAvailable(isAvailable)
        }
    }

    return (
        <>
            <Stack spacing={3} alignItems='flex-start'>
                <Typography variant='h4'>
                    Informacion de tu comercio
                </Typography>

                <Stack direction='row' sx={{ width: '100%' }}>
                    <TextField
                        label="Identificador del comercio"
                        variant="outlined"
                        value={storeID}
                        onChange={e => {
                            const regex = /^[a-zA-Z0-9]*$/;
                            const input = e.target.value.toLocaleLowerCase()
                            if (regex.test(input) && input.length < 40) {
                                setStoreID(input)
                            }
                        }}
                        required
                        fullWidth
                        helperText="Maximo 40 caracteres"
                        error={!storeIDAvailable && storeID !== userData.menuid}
                    />

                    <Helper style={{ marginBottom: '15px' }}
                        text='Recuerda que el identificador indica como se muestra el link a tu comercio.
                     Al cambiarlo deberás actualizar tus codigos QR y links en los lugares donde los hayas compartido'
                    />
                </Stack>

                {storeIDAvailable === null ? null : storeIDAvailable === true ?
                    <Typography color='green' variant='h6'>El ID se encuentra disponible</Typography> :
                    <Typography color='error' variant='h6'>El ID no se encuentra disponible</Typography>}

                <Button variant='contained'
                    onClick={() => checkIDAvailability()}>
                    Comprobar disponibilidad
                </Button>

                <Divider sx={{ width: '100%' }} />

                <Typography variant='h5'>Numero de Whatsapp</Typography>

                <Stack direction='row' sx={{ width: '100%' }}>
                    <TextField
                        label="Numero de telefono (15...)"
                        variant="outlined"
                        value={storePhone}
                        onChange={e => {
                            const numberRegex = /^15\d{0,13}$|^1$|^$/

                            if (numberRegex.test(e.target.value)) {
                                setStorePhone(e.target.value)
                            }
                        }}
                        fullWidth
                        helperText="Telefono con 15 adelante y sin espacios. Ej: 15 1234 5678"
                    />

                    <Helper style={{ marginBottom: '15px' }}
                        text='Este será el numero donde te llegarán los pedidos de tus clientes, asegurate de que sea el correcto'
                    />
                </Stack>


                <Button
                    variant='contained'
                    color='success'
                    endIcon={<WhatsAppIcon />}
                    onClick={checkPhoneNumber.bind(this)}
                >
                    Verificar
                </Button>

                <Divider sx={{ width: '100%' }} />

                <Stack direction='row' sx={{ width: '100%' }}>
                    <TextField
                        label="Nombre del comercio"
                        variant="outlined"
                        value={title}
                        onChange={e => e.target.value.length >= 100 ? null : setTitle(e.target.value)}
                        required
                        fullWidth
                        helperText="Maximo 100 caracteres"
                    />
                    <Helper style={{ marginBottom: '15px' }}
                        text='El nombre de tu comercio es el que aparecerá primero en tu menú. Cambiarlo NO modifica ningún link ni codigo QR'
                    />
                </Stack>

                <TextField
                    label="Descripcion"
                    variant="outlined"
                    value={description}
                    onChange={e => e.target.value.length >= 1000 ? null : setDescription(e.target.value)}
                    fullWidth
                    multiline
                    helperText="Maximo 1000 caracteres"
                />

                <TextField
                    label="Dirección"
                    variant="outlined"
                    value={address}
                    onChange={e => e.target.value.length >= 100 ? null : setAddress(e.target.value)}
                    fullWidth
                    helperText="Maximo 100 caracteres"
                />

                <Divider sx={{ width: '100%' }} />

                <Stack direction='row' justifyContent='space-evenly' flexWrap='wrap' sx={{ width: '100%' }}>
                    <List className={Styles.splitContainerComponent}>
                        <Typography variant='h5'>Metodos de entrega</Typography>
                        {Object.keys(DELIVERY_METHODS).map((method, index) => {
                            return (
                                <div key={index}>
                                    <ListItem disablePadding>
                                        <ListItemButton role={undefined} onClick={() => handleCheckToggle(method, deliveryOptions, setDeliveryOptions)} dense>
                                            <ListItemIcon>
                                                <Checkbox
                                                    edge="start"
                                                    checked={deliveryOptions.indexOf(method) !== -1}
                                                    tabIndex={-1}
                                                    disableRipple
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary={
                                                method === DELIVERY_METHODS.delivery ? "Delivery" :
                                                    method === DELIVERY_METHODS.takeaway ? "Take Away" :
                                                        method === DELIVERY_METHODS.inPlace ? "Comer en el lugar" : null} />
                                        </ListItemButton>
                                    </ListItem>
                                    <Divider sx={{ width: '100%' }} />
                                </div>
                            )
                        })}
                    </List>

                    <List className={Styles.splitContainerComponent}>
                        <Typography variant='h5'>Formas de pago</Typography>
                        {Object.keys(PAYMENT_METHODS).map((method, index) => {
                            return (
                                <div key={index}>
                                    <ListItem disablePadding>
                                        <ListItemButton role={undefined} onClick={() => handleCheckToggle(method, paymentOptions, setPaymentOptions)} dense>
                                            <ListItemIcon>
                                                <Checkbox
                                                    edge="start"
                                                    checked={paymentOptions.indexOf(method) !== -1}
                                                    tabIndex={-1}
                                                    disableRipple
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary={
                                                method === PAYMENT_METHODS.cash ? "Efectivo" :
                                                    method === PAYMENT_METHODS.mercadopago ? "MercadoPago" :
                                                        method === PAYMENT_METHODS.transfer ? "Transferencia" : null} />
                                        </ListItemButton>
                                    </ListItem>
                                    <Divider sx={{ width: '100%' }} />
                                </div>
                            )
                        })}
                    </List>
                </Stack>

                <Divider sx={{ width: '100%' }} />

                <Typography variant='h5'>Horarios de atencion</Typography>

                <Typography>Si una opción de entrega tiene todos sus horarios como 'cerrado', esa opcion no aparecerá disponible como opción de entrega.
                    <br />
                    Ej: "Delivery" se encuentra todos los dias cerrado, entonces los clientes solamente podrán elegir "Take Away".
                </Typography>


                {deliveryOptions.length === 0 ?
                    <Typography variant='h6' color='error'>Debes seleccionar al menos una forma de envio</Typography> :

                    <Stack direction='row' justifyContent='space-evenly' flexWrap='wrap' sx={{ width: '100%' }}>

                        {deliveryOptions.some(elem => elem === DELIVERY_METHODS.delivery) ?
                            <div className={Styles.splitContainerComponent}>
                                <Typography variant='h5'>Delivery</Typography>
                                <Schedule
                                    schedule={deliverySchedule}
                                    setSchedule={setDeliverySchedule}
                                />
                            </div> : null}

                        {deliveryOptions.some(elem => elem === DELIVERY_METHODS.takeaway)
                            || deliveryOptions.some(elem => elem === DELIVERY_METHODS.inPlace) ?
                            <div className={Styles.splitContainerComponent}>
                                <Typography variant='h5'>Take away y/o comer en el lugar</Typography>
                                <Schedule
                                    schedule={takeawaySchedule}
                                    setSchedule={setTakeawaySchedule}
                                />
                            </div> : null}

                    </Stack>
                }

                <Divider sx={{ width: '100%' }} />

                <Stack spacing={1}>
                    <Typography variant='h5'>Costos en envío</Typography>
                    <Typography>La información acerca de los costos de envío se muestra al entrar al menú y dependiendo del tipo de costo puede o no mostrarse en el pedido final</Typography>

                    <Typography variant='h6'>Consultar / Gratis</Typography>
                    <Typography>No se incluirá ninguna información extra en el pedido final</Typography>

                    <Typography variant='h6'>Precio fijo</Typography>
                    <Typography>Se incluirá por ejemplo "+$500 envío"</Typography>

                    <Typography variant='h6'>Según la distancia</Typography>
                    <Typography>Se incluirá "+ envío" en el total del pedido pero sin especificar el rango de precios</Typography>

                    <Typography variant='h6'>Gratis por el tamaño de la compra</Typography>
                    <Typography>Si configuraste que el envio sea gratis para compras mayores a x valor se agregará "+ envío (bonificado)" en el pedido final</Typography>
                </Stack>

                <ToggleButtonGroup
                    sx={{ alignSelf: 'center' }}
                    orientation={bigScreen ? 'horizontal' : 'vertical'}
                    color="primary"
                    value={deliveryOption}
                    exclusive
                    onChange={(event, newAlignment) => setDeliveryOption(newAlignment)}
                >
                    <ToggleButton value={0}>Consultar</ToggleButton>
                    <ToggleButton value={1}>Precio fijo</ToggleButton>
                    <ToggleButton value={2}>Segun la distancia</ToggleButton>
                    <ToggleButton value={3}>Gratis</ToggleButton>
                </ToggleButtonGroup>


                {deliveryOption === 0 ?
                    <Typography variant='h6'>Los clientes deberán consultarte sobre el costo de envio al momento de realizar el pedido</Typography>
                    : deliveryOption === 1 ?
                        <FormControl sx={{ alignSelf: 'center' }}>
                            <InputLabel>Costo fijo</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                label="Costo fijo"
                                onChange={e => setIfValidPrice(e.target.value, (value) => {
                                    setDeliveryCost(prev => { return { from: value, to: value, free: prev.free } })
                                })}
                                value={deliveryCost.from}
                            />
                        </FormControl>
                        : deliveryOption === 2 ?
                            <Stack direction='row' flexWrap='wrap' justifyContent='space-evenly' sx={{ width: '100%' }}>
                                <FormControl>
                                    <InputLabel>Costo minimo</InputLabel>
                                    <OutlinedInput
                                        startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                        label="Costo minimo"
                                        onChange={e => setIfValidPrice(e.target.value, (value) => {
                                            setDeliveryCost(prev => { return { from: value, to: prev.to, free: prev.free } })
                                        })}
                                        value={deliveryCost.from}
                                    />
                                </FormControl>
                                <FormControl>
                                    <InputLabel>Costo maximo</InputLabel>
                                    <OutlinedInput
                                        startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                        label="Costo maximo"
                                        onChange={e => setIfValidPrice(e.target.value, (value) => {
                                            setDeliveryCost(prev => { return { from: prev.from, to: value, free: prev.free } })
                                        })}
                                        value={deliveryCost.to}
                                    />
                                </FormControl>
                            </Stack>
                            : deliveryOption === 3 ?
                                <Typography variant='h6'>Todos tus envios aparecerán como gratis independientemente del recorrido y el tamaño de la compra</Typography>
                                : null}


                {deliveryOption === 3 ? null :
                    <>
                        <FormControlLabel control={<Checkbox />} label="Ofrecer envío gratis en compras que superen cierto valor"
                            onChange={e => {
                                setDeliveryCost(prev => { return { from: prev.from, to: prev.to, free: e.target.checked ? 0 : -1 } })
                                setOfferFreeDelivery(e.target.checked)
                            }}
                            checked={offerFreeDelivery}
                        />

                        {!offerFreeDelivery ? null :
                            <FormControl sx={{ alignSelf: 'center' }}>
                                <InputLabel htmlFor="outlined-adornment-amount">Gratis en pedidos mayores a</InputLabel>
                                <OutlinedInput
                                    id="outlined-adornment-amount"
                                    startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                    label="Gratis en pedidos mayores a"
                                    value={deliveryCost.free}
                                    required
                                    onChange={e => setIfValidPrice(e.target.value, (value) => {
                                        setDeliveryCost(prev => { return { from: prev.from, to: prev.to, free: value } })
                                    })}
                                />
                            </FormControl>
                        }
                    </>
                }

                <Divider sx={{ width: '100%' }} />

                <Typography variant='h5'>Redes sociales</Typography>
                <TextField
                    label="Twitter"
                    variant="outlined"
                    value={twitter}
                    onChange={e => e.target.value.includes(" ") ? null : setTwitter(e.target.value)}
                    fullWidth
                    InputProps={{
                        startAdornment: <InputAdornment position="start">https://www.twitter.com/</InputAdornment>
                    }}
                    helperText="Nombre de tu cuenta de twitter sin el @"
                />

                <TextField
                    label="Facebook"
                    variant="outlined"
                    value={facebook}
                    onChange={e => e.target.value.includes(" ") ? null : setFacebook(e.target.value)}
                    fullWidth
                    InputProps={{
                        startAdornment: <InputAdornment position="start">https://www.facebook.com/</InputAdornment>
                    }}
                />

                <TextField
                    label="Instagram"
                    variant="outlined"
                    value={instagram}
                    onChange={e => e.target.value.includes(" ") ? null : setInstagram(e.target.value)}
                    fullWidth
                    InputProps={{
                        startAdornment: <InputAdornment position="start" >https://www.instagram.com/</InputAdornment>
                    }}
                    helperText="Nombre de usuario en instagram"
                />
            </Stack >

            <SaveBanner
                setPreventNavigation={setPreventNavigation}
                storeModified={storeModified}
                onUpdate={onUpdate}
                preventUpdate={!storeIDAvailable && storeID !== userData.menuid}
                preventedUpdateMessage={'Comprueba que el nuevo identificador de tienda esté disponible'}
            />

            <EasySnackBar
                severity='error'
                key='3'
                message={errorMessage}
                setMessage={setErrorMessage}
            />

            <EasySnackBar
                severity='success'
                key='2'
                message={successMessage}
                setMessage={setSuccessMessage}
            />
        </>
    )
}